import Instagram from '@/assets/social/instagram_02.svg';
import Linkedin from '@/assets/social/linkedin_02.svg';
import XLogo from '@/assets/social/x-logo.svg';
import Facebook from '@/assets/social/facebook.svg';
import Blog from '@/assets/social/blog.svg';
import Youtube from '@/assets/social/youtube_02.svg';
import Pinterest from '@/assets/social/pinterest.svg';
import TikTok from '@/assets/social/tiktok.svg';

interface SocialImageProps {
  type?: string;
  className?: string;
}

const SocialImage = ({ type, className }: SocialImageProps) => {
  if (type === 'Instagram') {
    return <Instagram className={className} />;
  } else if (type === 'Linked In' || type === 'LinkedIn') {
    return <Linkedin className={className} />;
  } else if (type === 'Twitter') {
    return <XLogo className={className} />;
  } else if (type === 'Facebook') {
    return <Facebook className={className} />;
  } else if (type === 'Blog') {
    return <Blog className={className} />;
  } else if (type === 'Youtube') {
    return <Youtube className={className} />;
  } else if (type === 'Pinterest') {
    return <Pinterest className={className} />;
  } else if (type === 'TikTok') {
    return <TikTok className={className} />;
  }

  return null;
};

export default SocialImage;
